import React, { Component } from 'react';
import '../App.css';
import CeilingSpraying from "../components/page/ceiling-spraying";
import { Helmet } from 'react-helmet';

class Home4 extends Component {
  render() {
    return (
      <div>      
        <Helmet>
        <title>Advanced Spray Decorators</title>
            <meta name="description" content="Domestic, Commercial & Industrial Projects, Nationwide. Spraying & Restoring Ceilings, Walls, Cladding, Shop Fronts, Roller Shutters & Intumescent coatings." />
            <meta name="keywords" content="Ceiling Sprayers, Ceiling Sprayer, Shop Front Sprayer, Shop Front Spraying, Shop Front Sprayers, Shop Front Painter, Ceiling Tiles, Ceiling Painter, shop front wet spraying, Ceiling restoration, Ceiling maintenance, shop front maintenance, new shop front, New ceilings, Ceiling fitters, shop front fitters, powder coating, Suspended ceilings, aluminium windows, Metal pan ceilings, shop front restoration, Ceiling repaint, shopfront spaying, Ceiling grids, shop front refurbishment, Suspended ceiling prices, shop front renovation, Spray decorators, Shop front repairs, Shop front replacement, Curtain wall spraying, Intumescent coatings " />
            <meta name="application-name" content="Advanced Spray Decorators" />
            <meta property="og:url" content="https://www.advancedspraydecorators.co.uk" />
            <meta property="og:title" content="Advanced Spray Decorating" />       
            <link rel="icon" type="image/png" href="favicon.ico" sizes="32x32" />
        </Helmet>
        <CeilingSpraying />
      </div>
    );
  }
}

export default Home4;



// WEBPACK FOOTER //
// ./src/views/home4.js